<div class="container" *ngIf="_messageShown">
    <div class="message" [class.error]="_type | equals: 'error'" [class.info]="_type | equals: 'info'" [class.warning]="_type | equals: 'warning'">
        <div class="header">
            <div class="icon">
                <i class="fas fa-info-circle" *ngIf="_type | equals: 'info'"></i>
                <i class="fas fa-exclamation-circle" *ngIf="_type | equals: 'error'"></i>
                <i class="fas fa-exclamation-triangle" *ngIf="_type | equals: 'warning'"></i>
            </div>
            <h1>{{ _title }}</h1>
            <div class="close" (click)="_close()">
                <i class="fas fa-times"></i>
            </div>
        </div>
        <div class="body">
            {{ _message }}
        </div>
        <div class="footer">
            <ng-container *ngFor="let button of _buttons">
                <div class="button" (click)="_handleClickButton(button)">{{ button.text }}</div>
            </ng-container>
        </div>
    </div>
</div>